import React from 'react';

interface ChevronDownIconProps {
    className?: string;
}

const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({ className = "w-2 h-1", ...props }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 10 6" {...props}>
        <path d="M1.2 0.8a.8.8 0 0 1 1.13 0L5 3.47 7.67.8a.8.8 0 1 1 1.13 1.13l-3.2 3.2a.8.8 0 0 1-1.13 0l-3.2-3.2A.8.8 0 0 1 1.2.8Z" fill="currentColor"/>
    </svg>
);

export default ChevronDownIcon;
